import { InjectionToken } from '@angular/core';
import { IAnalyticsService } from '../services/analytics-service.interface';

export const ANALYTICS_SERVICE_TOKEN = new InjectionToken<IAnalyticsService>('ANALYTICS_SERVICE_TOKEN');
